import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { CommuneState } from './commune.state';
import { AtlasConfiguration } from '../../models/commune';
import { withWidgetConfig } from './commune.widget-configs';

export function withBaseConfig() {
  return signalStoreFeature(
    {
      state: type<CommuneState>(),
    },
    withWidgetConfig(),
    withComputed(
      ({
        baseMapConfig,
        baseBarChartConfig,
        baseLineConfig,
        basePieConfig,
        baseScatterConfig,
        baseTableConfig,
        basePolarConfig,
        baseRadarConfig,
      }) => ({
        baseConfig: computed((): AtlasConfiguration => {
          return {
            headline: '',
            logo: '',
            colorset: undefined,
            startTeaser: '',
            absoluteDecimals: 0,
            relativeDecimals: 1,
            miscValues: [],
            map: baseMapConfig(),
            bar: baseBarChartConfig(),
            line: baseLineConfig(),
            scatter: baseScatterConfig(),
            pie: basePieConfig(),
            radar: baseRadarConfig(),
            polarArea: basePolarConfig(),
            table: baseTableConfig(),
            bubble: baseScatterConfig(),
            adder: null,
            text: null,
            teaser: null,
            info: null,
            landingPageItems: [],
            navigation: [],
          };
        }),
      })
    )
  );
}
